export default function isDeluxeSampleOptionUtil (option) {
  return /premium sample/i.test(option)
}
